export const COMPONENT_STACK_MAX_LENGTH = 4000;

/**
 * Properties sent with a render error caught by the app error boundary.
 * Mobile Safari reports some errors (e.g. stack overflows) against the page
 * URL, so the React component stack is the only reliable pointer to the code.
 *
 * @param options.componentStack - React component stack from `componentDidCatch`
 * @param options.route - Next.js route pattern, e.g. `/glossary/[slug]`
 * @param options.path - Path the visitor was on
 * @param options.viewport - Window size at the time of the error
 * @returns Exception properties for `posthog.captureException`
 */
export const getErrorBoundaryCaptureProperties = (options: {
	componentStack?: string | null;
	route: string;
	path: string;
	viewport?: { width: number; height: number };
}) => {
	const { componentStack, route, path, viewport } = options;

	return {
		source: "react_error_boundary",
		component_stack:
			componentStack?.slice(0, COMPONENT_STACK_MAX_LENGTH) || undefined,
		top_component: componentStack?.match(/at (\S+)/)?.[1],
		route,
		path,
		viewport_width: viewport?.width,
		viewport_height: viewport?.height,
	};
};
